module.exports = __webpack_public_path__ + "img/search_icon.0f873dc2.svg";